import { render, staticRenderFns } from "./CartOrderOnlinePickUp.vue?vue&type=template&id=5050a24f&scoped=true&"
import script from "./CartOrderOnlinePickUp.vue?vue&type=script&lang=js&"
export * from "./CartOrderOnlinePickUp.vue?vue&type=script&lang=js&"
import style0 from "./CartOrderOnlinePickUp.vue?vue&type=style&index=0&id=5050a24f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050a24f",
  null
  
)

export default component.exports